import { createContext, useContext } from 'react';

export const MCDialogContext = createContext<any>(null);

export const useMobileContextMenu = () => {
  return useContext(MCDialogContext);
};
